<template>
  <div class="mt-2 align-content-center">
    <h6>
      Productos
    </h6>

    <BaseMultiselect
      v-model="data.selection"
      track-by="vendor_product"
      label="vendor_product"
      :multiple="true"
      :options="productOptions"
      :allow-empty="true"
      required
      placeholder="Buscar"
      select-label=""
      caret-icon-name="fa-search"
      @search-change="onProductSearchChange"
      @select="saveValue"
      @remove="removeOption"
    />
  </div>
</template>

<script>
import BaseMultiselect from '@/app/shared/components/BaseMultiselect'
import indexComposition from '@/app/shared/components/async_product_multiselect/compositions/Index'

export default {
  name: 'AsyncProductMultiselect',
  components: {
    BaseMultiselect
  },
  props: {
    selectedAsyncProductFilters: {
      type: Object,
      default: () => { return {} }
    }
  },
  setup (props, context) {
    const { onProductSearchChange, productOptions, saveValue, data, removeOption, buildFilters } = indexComposition(props, context)
    return {
      onProductSearchChange, productOptions, saveValue, data, removeOption, buildFilters
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/app/shared/components/async_product_multiselect/Index.vue